<template>
  <div class="bg">
    <div class="home-container">
      <div class="px-6 pb-12 flex flex-col lg:flex-row">
        <div class="lg:w-full lg:order-1">
          <div class="lg:px-12">

            <div class="py-4 pb-0 font-title font-bold text-xl tracking-tight text-red-500">
              Speed things up....
            </div>
            <div class="py-4 font-title font-black text-5xl tracking-tighter leading-none text-black">
              Assisted Creative Coding
            </div>
            <!-- <div class=" text-lg leading-relaxed py-3">
              To celebrate the Gift of Life, I try to build hard things. Nice things are hard to be here, but it's always worth it.
            </div>
            <div class="text-lg leading-relaxed text-gray-700">
              “When you create, it exists; Therefore, your loving act, is the power source of you dream life through nurturing realtionships.” - Wong Lok
            </div> -->

            <div class="pb-6">
              <img class="bordergray border shadow-2xl rounded-lg" src="./img/editor.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="postcss">
.bordergray{
  border-color: #d5d5d5;
}
</style>
